const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Contact service",
  description: "Welcome to contact service",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Rehviturundusmeeskond",
    car: "Automaüügimeeskond",
    lkw: "Veoautomeeskond",
    em_otr: "EM/OTR meeskond",
    farm_tractor: "Põllumajandustraktorite meeskond",
    bandag: "Bandag meeskond",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
